// SPAC-2796, SPAC-2771: slot 1 opened with `#login` ("Add account", manual `/#login`, sign-out to the login screen)
// must stay on the login screen even if other slots are logged in. `useHistoryBack` strips the hash right after load,
// so a reload of that page comes without `#login`: remember the intent in `sessionStorage` (per tab) and keep it
// only for reloads. Any other navigation to plain "/" (address bar, link, bookmark) forgets it.

const STORAGE_KEY = 'tt-explicit-login';

function getNavigationType(): string | undefined {
  try {
    const [entry] = performance.getEntriesByType('navigation') as PerformanceNavigationTiming[];
    return entry?.type;
  } catch (err) {
    return undefined;
  }
}

/**
 * Whether this page load of slot 1 is an explicit request to log in. Call once per page load.
 * @param initialHash - `location.hash` captured at page load
 * @param navigationType - `PerformanceNavigationTiming.type` of this page load
 */
export function checkExplicitLogin(initialHash: string, navigationType = getNavigationType()) {
  try {
    if (initialHash.includes('login')) {
      sessionStorage.setItem(STORAGE_KEY, '1');
      return true;
    }

    if (navigationType === 'reload' && sessionStorage.getItem(STORAGE_KEY)) {
      return true;
    }

    sessionStorage.removeItem(STORAGE_KEY);
  } catch (err) {
    // Storage is unavailable: only the hash counts
    return initialHash.includes('login');
  }

  return false;
}
